import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_SENTRY_DSN : '',
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [],
});
